package com.appcreator.blueprint.conditions.data

import com.appcreator.blueprint.core.Condition
import com.appcreator.blueprint.core.ConditionClass
import com.appcreator.blueprint.core.InputProperty
import com.appcreator.blueprint.core.StringDefault
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
@SerialName("Equals")
@ConditionClass(
    group = "Data",
    title = "Equals",
    availableFrom = "0.0.1"
)
data class EqualsCondition(
    @InputProperty(
        title = "Data",
        availableFrom = "0.0.1"
    )
    @StringDefault("")
    val data: String,
    @InputProperty(
        title = "Equals",
        availableFrom = "0.0.1"
    )
    @StringDefault("")
    val value: String
): Condition
